<ngx-charts-bar-horizontal [results]="data"
                           [view]="options.view"
                           [scheme]="options.scheme"
                           [schemeType]="options.schemeType"
                           [legend]="options.legend"
                           [legendTitle]="options.legendTitle"
                           [legendPosition]="options.legendPosition"
                           [xAxis]="options.xAxis"
                           [yAxis]="options.yAxis"
                           [showGridLines]="options.showGridLines"
                           [showXAxisLabel]="options.showXAxisLabel"
                           [showYAxisLabel]="options.showYAxisLabel"
                           [xAxisLabel]="options.xAxisLabel"
                           [yAxisLabel]="options.yAxisLabel"
                           [roundEdges]="options.roundEdges"
                           (select)="onSelect($event)" >

</ngx-charts-bar-horizontal>
